var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkillsDavinci(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "skills_davinci",
    transform: "translate(-859 -773)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path27",
    d: "M28.128,50.13H26.764a.546.546,0,0,0-.191-.029c-.728-.035-1.451-.093-2.167-.191a22.388,22.388,0,0,1-3.941-.878A23.113,23.113,0,0,1,14.312,46,23.1,23.1,0,0,1,5.9,35.192a22.545,22.545,0,0,1-1.41-6.528,1.154,1.154,0,0,0-.063-.364V25.926a1.047,1.047,0,0,0,.063-.323c.029-.537.086-1.075.156-1.606a22.69,22.69,0,0,1,2.282-7.3A22.956,22.956,0,0,1,25.5,4.193a4.8,4.8,0,0,0,.757-.063h2.334a2.878,2.878,0,0,0,.543.04,26.034,26.034,0,0,1,2.756.376,22.73,22.73,0,0,1,8,3.229,22.972,22.972,0,0,1,5.073,4.442A22.826,22.826,0,0,1,50.032,22.8a19.139,19.139,0,0,1,.369,3.4c0,.076.017.156.023.231V27.79a1.4,1.4,0,0,0-.029.271c0,.219,0,.44-.017.659a24.018,24.018,0,0,1-.671,4.142,22.948,22.948,0,0,1-20.872,17.2c-.228.026-.471.021-.708.071Z",
    transform: "translate(854.575 768.87)",
    fill: "#5637fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path37",
    d: "M25.815,19.486A4.616,4.616,0,0,0,26,20.833a9.434,9.434,0,0,0,1.094,2.446,22.76,22.76,0,0,0,3.832,4.588,1.607,1.607,0,0,0,.41.281.506.506,0,0,0,.458.011,1.193,1.193,0,0,0,.4-.288c.5-.518,1-1.037,1.471-1.573a25.493,25.493,0,0,0,1.881-2.384,12.355,12.355,0,0,0,1.336-2.429,5.4,5.4,0,0,0,.4-2.688,6.059,6.059,0,0,0-1.945-3.877A5.377,5.377,0,0,0,30.7,13.5a5.972,5.972,0,0,0-4.888,5.991Z",
    transform: "translate(850.203 766.971)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path39",
    d: "M42.412,44.538a4.986,4.986,0,0,1-1.16-.119,5.053,5.053,0,0,1-2.97-1.757,10.9,10.9,0,0,1-1.209-1.881,19.816,19.816,0,0,1-1.029-2.427,26.385,26.385,0,0,1-.895-3.054.834.834,0,0,1,.656-1.14c.813-.254,1.631-.481,2.466-.665a16.884,16.884,0,0,1,4.2-.449,8.906,8.906,0,0,1,1.2.129,5.168,5.168,0,0,1,2.921,1.567,5.629,5.629,0,0,1,1.566,5.07,5.756,5.756,0,0,1-5.74,4.724Z",
    transform: "translate(848.303 762.96)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33",
    d: "M20.291,44.538a4.986,4.986,0,0,0,1.16-.119,5.053,5.053,0,0,0,2.97-1.757,10.9,10.9,0,0,0,1.209-1.881,19.817,19.817,0,0,0,1.029-2.427,26.386,26.386,0,0,0,.895-3.054.834.834,0,0,0-.656-1.14c-.813-.254-1.631-.481-2.466-.665a16.884,16.884,0,0,0-4.2-.449,8.906,8.906,0,0,0-1.2.129,5.168,5.168,0,0,0-2.921,1.567,5.629,5.629,0,0,0-1.566,5.07,5.756,5.756,0,0,0,5.74,4.724Z",
    transform: "translate(852.525 762.96)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsDavinci);
export default __webpack_public_path__ + "static/media/skills_davinci.e5fe1d8c1ba8a293a751e1c236fd2d72.svg";
export { ForwardRef as ReactComponent };